import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { selectSessionSelector } from '@mm/state/selectors/userSelector';
import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';
import { useSelector } from 'react-redux';
import {
  BOOK_DEMO_ENTERPRISE,
  BOOK_DEMO_NON_ENTERPRISE,
  BOOK_NON_SQL_DISCO_CALL,
} from '../../../dashboard/pages/XRayOnboarding/WebsiteReportSummary/constants';

export const useBookDemo = (utmTags?: string) => {
  const activeCompany = useSelector(activeCompanySelector);
  const facebookPage = useSelector(activeFacebookPageSelector);
  const { userAttributes } = useSelector(selectSessionSelector) || {};
  const rootElement = document.getElementById('app');
  const isAgency = activeCompany?.companyAttributes?.agency;
  const isSQL = activeCompany?.consideredQualified;

  const isEligibleForDemo =
    isSQL &&
    !(
      facebookPage?.subscription ||
      activeCompany?.bookAnEnterprise ||
      userAttributes?.requestedDemo
    );

  const websiteTraffic = activeCompany?.trafficData;
  const totalTraffic =
    (websiteTraffic?.trafficType?.organic || 0) +
    (websiteTraffic?.trafficType?.paid || 0);

  const discoUrl = `${BOOK_NON_SQL_DISCO_CALL}?${utmTags}`;

  const demoUrl = isAgency
    ? `${BOOK_DEMO_ENTERPRISE}?${utmTags}`
    : isSQL
    ? `${BOOK_DEMO_NON_ENTERPRISE}?${utmTags}`
    : discoUrl;

  return {
    isEligibleForDemo,
    rootElement,
    websiteTraffic,
    totalTraffic,
    demoUrl,
    discoUrl,
  };
};
